<template>
  <div class="" >
    <div v-if="!mobileView" id="mySidenav" class="sidenav cursor-pointer">
      
      <div class="pt-4 navContainer" :class="{ 'min-width': !drawerIsOpen}">
        <div class="h-12 ico_list d_icon_box items-center mb-3 hover:shadow-lg text-gray3 hover:text-primary" :class="{ 'no-shadow': !drawerIsOpen }">
          <div class="d_icon_child">
            <div v-if="!drawerIsOpen" @click="HandelOpenDrower()" style="height: 49px; width: 55px;" class=" flex justify-center items-center cursor-pointer ">
              <right-angle-svg-copy class="" :width="'20px'" :color="'#949494'" :height="'28px'" />
            </div>
            <p v-else @click="HandelCloseDrower()" class="flex justify-start items-center cursor-pointer" style="height: 49px; width: 100%;">
              <left-angle-svg class="ml-4" :width="'20px'" :color="'#949494'" :height="'28px'" />
            </p>
          </div>
        </div>
        <div
          v-for="item in filteredMenuItems"
          :key="item.path"
          @click.stop="routeTo(item)"
          class="h-12 d_icon_box items-center mb-3 hover:shadow-lg text-gray3 hover:text-primary"
          :class="{ 'no-shadow': !drawerIsOpen }"
        >
          <div class="d_icon_child">
            <div :class="item.meta.selected ? 'text-primary ' : ''" class="rounded heading-2">
              <component v-if="item.meta.svgComponent" :is="item.meta.svgComponent" :width="'30px'" :height="'30px'" :color="item.meta.selected ? '#1295BA' : '#727272'" />
              <i v-else style="height:30px; width:30px" :class="item.meta.iconClass"></i>
              <!-- <span v-if="!drawerIsOpen" class="tooltiptext heading-4 bg-transparent whitespace-nowrap rounded">{{ item.meta.title.length > 7 ? item.meta.title.substr(0, 5) + '..' : item.meta.title }}</span> -->
              <span v-if="!drawerIsOpen" class="tooltiptext heading-4 bg-transparent whitespace-nowrap rounded">{{ item.meta.title }}</span>
            </div>
          </div>
          <span v-if="drawerIsOpen" :class="item.meta.selected ? 'text-primary ' : ''" class="d_items_text  font-bold">{{ item.meta.title }}</span>
        </div>
      </div>
    </div>
    <div v-else class="sv_sidenav_box">
      <div v-click-overLay="closeLeftNavDrawer" id="sv_smySidenav" class="sv_sidenav bg-white">
        <div class="pt-4">
        <div
          v-for="item in filteredMenuItems"
          :key="item.path"
          @click="routeTo(item)"
          class="h-12 ico_list d_icon_box items-center mb-4 hover:shadow-lg text-gray3 hover:text-primary"
          :class="{ 'no-shadow': !drawerIsOpen }"
        >
          <div class="d_icon_child">
            <div :class="item.meta.selected ? 'text-primary ' : ''" class="rounded heading-2">
              <component v-if="item.meta.svgComponent" :is="item.meta.svgComponent" :width="'30px'" :height="'30px'" :color="item.meta.selected ? '#1295BA' : '#727272'" />
              <i v-else style="height:30px; width:30px" :class="item.meta.iconClass"></i>
            </div>
          </div>
          <span :class="item.meta.selected ? 'text-primary ' : ''" class="d_items_text  font-bold">{{ item.meta.title }}</span>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import {FilterPermissions} from '@/utils/Permissions.js'
import Vue from 'vue'
Vue.directive('click-overLay', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})
// import colors from '@/assets/colors.json'
import router from '@/router/index.js'
import RightAngleSvgCopy from '../../../assets/images/svg/RightAngleSvg copy.vue'
import LeftAngleSvg from '../../../assets/images/svg/LeftAngleSvg.vue'
import switchSvg from '../../../assets/images/svg/switchSvg.vue'
export default {
  components: {RightAngleSvgCopy, LeftAngleSvg, switchSvg},
  name: "leftNavbar",
  computed: {
    filteredMenuItems() {
      const jobUserInfo = JSON.parse(localStorage.getItem('jobUserInfo') || '{}')
      const isAdmin = jobUserInfo.isAdmin === true || jobUserInfo.isOwner === true
      let items = isAdmin ? this.menuItems : this.menuItems.filter(item => {
        const nonAdminPaths = ['/dashboard', '/schedule', '/job', '/task', '/invoice', '/shift', '/expense', '/switchorganization']
        return nonAdminPaths.includes(item.path)
      })
      if (jobUserInfo.totalOrganizations <= 1) {
        items = items.filter(item => item.path !== '/switchorganization')
      }
      return items
    }
  },
  data() {
    return {
      getPermission: FilterPermissions(''),
      showCall: false,
      mobileView: false,
      extraSmall: false,
      drawerIsOpen: false,
      menuItems: [
        {
          path: '/dashboard',
          name: 'dashboard1',
          isShowPermission: true,
          permissionSlug: '',
          meta: {selected: false, routIconSize: {height: '40px', width: '40px', color: ''},
          iconClass: 'fa-solid fa-house', title: 'Home', loadPage: 'dashboard'},
        },
        {
          path: '/schedule',
          name: 'schedule',
          isShowPermission: true,
          permissionSlug: '',
          meta: {selected: false, routIconSize: {height: '40px', width: '40px', color: ''},
          iconClass: 'fa-solid fa-truck', title: 'Schedule', loadPage: 'schedule'},
        },
        {
          path: '/customer',
          name: 'customer',
          isShowPermission: false,
          permissionSlug: 'customer',
          meta: {selected: false, routIconSize: {height: '40px', width: '40px', color: ''},
          iconClass: 'fa-solid fa-users', title: 'Customer', loadPage: 'customer'},
        },
        // {
        //   path: '/lead',
        //   name: 'lead',
        //   isShowPermission: false,
        //   permissionSlug: 'lead',
        //   meta: {selected: false, routIconSize: {height: '40px', width: '40px', color: ''},
        //   iconClass: 'fas fa-comment-dollar', title: 'Lead', loadPage: 'lead'},
        // },
        {
          path: '/job',
          name: 'job',
          isShowPermission: false,
          permissionSlug: 'job',
          meta: {selected: false, routIconSize: {height: '40px', width: '40px', color: ''},
          iconClass: 'fa-solid fa-briefcase', title: 'Job', loadPage: 'job'},
        },
        // {
        //   path: '/visit',
        //   name: 'visit',
        //   isShowPermission: true,
        //   permissionSlug: '',
        //   meta: {selected: false, routIconSize: {height: '50px', width: '50px', color: ''},
        //   iconClass: 'fas fa-business-time', title: 'Visit', loadPage: 'visit'},
        // },
        {
          path: '/task',
          name: 'Tasks',
          isShowPermission: false,
          permissionSlug: 'task',
          meta: {selected: false, routIconSize: {height: '50px', width: '50px', color: ''},
          iconClass: 'fa-solid fa-clipboard-list', title: 'Task', loadPage: 'Task'},
        },
        // {
        //   path: '/request',
        //   name: 'request',
        //   isShowPermission: false,
        //   permissionSlug: 'request',
        //   meta: {selected: false, routIconSize: {height: '50px', width: '50px', color: ''},
        //   iconClass: 'fa-solid fa-code-pull-request', title: 'Request', loadPage: 'request'},
        // },
        {
          path: '/invoice',
          name: 'invoice',
          isShowPermission: false,
          permissionSlug: 'invoice',
          meta: {selected: false, routIconSize: {height: '40px', width: '40px', color: ''},
          iconClass: 'fa-solid fa-file-invoice-dollar', title: 'Invoice', loadPage: 'invoice'},
        },
        // {
        //   path: '/quotation',
        //   name: 'quotation',
        //   isShowPermission: false,
        //   permissionSlug: 'quote',
        //   meta: {selected: false, routIconSize: {height: '40px', width: '40px', color: ''},
        //   iconClass: 'fab fa-quora', title: 'Quote', loadPage: 'quotation'},
        // },
        {
          path: '/payment',
          name: 'payment',
          isShowPermission: true,
          permissionSlug: '',
          meta: {selected: false, routIconSize: {height: '40px', width: '40px', color: ''},
          iconClass: 'fa-solid fa-dollar-sign', title: 'Payment', loadPage: 'payment'},
        },
        {
          path: '/shift',
          name: 'shift',
          isShowPermission: false,
          permissionSlug: 'shift',
          meta: {selected: false, routIconSize: {height: '40px', width: '40px', color: ''},
          iconClass: 'fa-solid fa-clock', title: 'Shift', loadPage: 'shift'},
        },
        {
          path: '/expense',
          name: 'Expense',
          isShowPermission: false,
          permissionSlug: 'expense',
          meta: {selected: false, routIconSize: {height: '50px', width: '50px', color: ''},
          iconClass: 'fa-solid fa-money-bill-transfer', title: 'Expense', loadPage: 'Expense'},
        },
        {
          path: '/activity',
          name: 'activity',
          isShowPermission: true,
          permissionSlug: '',
          meta: {selected: false, routIconSize: {height: '40px', width: '40px', color: ''},
          iconClass: 'fa-solid fa-chart-line', title: 'Activity', loadPage: 'activity'},
        },
        {
          path: '/setting',
          name: 'Setting',
          isShowPermission: true,
          permissionSlug: '',
          meta: {selected: false, routIconSize: {height: '40px', width: '40px', color: ''},
          iconClass: 'fa-solid fa-gear', title: 'Setting', loadPage: 'Setting'},
        },
        {
          path: '/switchorganization',
          name: 'switchorganization',
          isShowPermission: true,
          permissionSlug: '',
          meta: {selected: false, routIconSize: {height: '40px', width: '40px', color: ''},
          svgComponent: 'switchSvg', title: 'Switch', loadPage: 'switchorganization'},
        }
      ]
    };
  },
  created() {
    this.resizeWindowHandler()
    window.addEventListener("resize", this.resizeWindowHandler);
  },
  mounted() {
    this.resizeWindowHandler();
     
    router.afterEach(() => {
      setTimeout(() => {
        this.setNavigation(this.$route.meta.loadPage)
      }, 200);
    })
    setTimeout(() => {
      this.setNavigation(this.$route.meta.loadPage)
    }, 500);
  },
  watch: {
  },
  methods: {
    HandelCloseDrower () {
      this.drawerIsOpen = false
      document.getElementById("letf_nav_container").style.marginRight = "71px";
      document.getElementById("mySidenav").style.minWidth = "55px";
    },
    HandelOpenDrower () {
      this.drawerIsOpen = true
      document.getElementById("letf_nav_container").style.marginRight = "240px";
      document.getElementById("mySidenav").style.minWidth = "225px";
      
    },
    closeLeftNavDrawer () {
      document.getElementById("overlay").style.display = "none";
      document.getElementById("sv_smySidenav").style.minWidth = "0px";
    },
    closeDrawer() {
    },
    openDrawer() {
    },
    routeTo(path) {
    console.log('path', path)
      let temp = FilterPermissions(path.permissionSlug)
      if (path.isShowPermission) {
        this.$router.push({ name: path.name }).catch(()=>{});
      } else {
        if (temp) {
          this.$router.push({ name: path.name }).catch(()=>{});
        } else {
          this.$store.dispatch('ShowSubPopup', {status: true, title: `You don't have permission to open ` + path.meta.title})
        }
      }
      if (this.mobileView) {
        this.closeLeftNavDrawer()
      }
      for (let index = 0; index < this.menuItems.length; index++) {
        // if (this.$route.name === this.menuItems[index].name) {
        if (this.$route.meta.loadPage === this.menuItems[index].meta.loadPage) {
          this.menuItems[index].meta.selected = true;
          // this.menuItems[index].meta.routIconSize.color = colors.white;
        } else {
          this.menuItems[index].meta.selected = false;
          // this.menuItems[index].meta.routIconSize.color = colors.gray2;
        }
      }
    },
    setNavigation (value) {
      if (this.$route.meta.title !== '') {
        if (this.$route.meta.title !== 'Job Detail' && this.$route.meta.title !== 'Quote Detail' && this.$route.meta.title !== 'Invoice Detail' && this.$route.meta.title !== 'Payment Detail') {
          document.title = this.$route.meta.title
        }
      }
      for (let index = 0; index < this.menuItems.length; index++) {
        // if (this.$route.name === this.menuItems[index].name) {
          // console.log("vvvvvvvv" value , this.routesList[index].meta);
        if (value === this.menuItems[index].meta.loadPage) {
          this.menuItems[index].meta.selected = true;
        } else {
          this.menuItems[index].meta.selected = false;
        }
      }
      console.log(this.menuItems[0].meta.selected);
    },
    resizeWindowHandler() {
      if (window.innerWidth < 1024) {
        this.mobileView = true;
      } else {
        this.mobileView = false;
      }
      if (window.innerWidth < 600) {
        this.extraSmall = true;
      } else {
        this.extraSmall = false;
      }
    },
  },
  beforeDestroy () {
  }
};
</script>
<style scoped>
#mySidenav {
  width: 55px !important;
  transition: width 0.5s;
}
#mySidenav:hover {
  /* width: 300px !important; */
}
#mySidenav:hover .ico_list{
  display: flex;
  align-items: center;
    /* --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / .1), 0 2px 4px -2px rgb(0 0 0 / .1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow); */
}


.d_icon_child {
  position: relative;
}

/* .tooltiptext {
  display: flex;
  align-items: center;
  justify-content: center !important;
  visibility: hidden;
  width: auto;
  height: 20px;
  color: #fff;
  text-align: center;
  padding: 4px 4px;
  background-color: #0000009c;
  position: absolute !important;
  z-index: 2147483647 !important;
  top: -39%;
  font-size: 12px;
} */

.d_icon_child:hover .tooltiptext {
  visibility: visible;
}
.no-shadow {
  box-shadow: none !important;
}
.min-width {
  width: 3% !important;
}

.navContainer  {
  height: 100%; 
  width: 227px;
  overflow-y: auto; 
  scrollbar-width: none;
  overflow-x: visible !important;
  position: fixed !important;
}

#mySidenav,
.sidenav,
.navContainer,
.d_icon_box,
.d_icon_child {
  overflow: visible !important;
}

/* proper tooltip look and positioning */
.tooltiptext {
  position: absolute;
  left: 30px; /* shift tooltip to the right of icon */
  top: 0%;
  transform: translateY(-50%);
  white-space: nowrap;
  background-color: #000000cc;
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  z-index: 99999;
}

/* show tooltip on hover */
.d_icon_child:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

</style>
